import { useState, useRef, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import {
  Wrapper,
  Trigger,
  Chevron,
  Dropdown,
  Option,
} from "./styles/CustomSelect.styles";

const dropdownVariants = {
  hidden: { opacity: 0, y: -8, transition: { duration: 0.15 } },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2, ease: [0.16, 1, 0.3, 1] },
  },
  exit: { opacity: 0, y: -8, transition: { duration: 0.12 } },
};

function CustomSelect({ value, options, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setOpen(false);
  };

  return (
    <Wrapper ref={ref}>
      <Trigger type="button" $open={open} onClick={() => setOpen(!open)}>
        <span>{value}</span>
        <Chevron
          viewBox="0 0 12 12"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          animate={{ rotate: open ? 180 : 0 }}
          transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
        >
          <path d="M3 4.5L6 7.5L9 4.5" />
        </Chevron>
      </Trigger>

      <AnimatePresence>
        {open && (
          <Dropdown
            variants={dropdownVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            {options.map((opt) => (
              <Option
                key={opt}
                type="button"
                $active={opt === value}
                onClick={() => handleSelect(opt)}
              >
                {opt}
              </Option>
            ))}
          </Dropdown>
        )}
      </AnimatePresence>
    </Wrapper>
  );
}

export default CustomSelect;
